import Cookies from 'js-cookie'
import router from '@/router'
import { isBot } from '@/utils'
import { jwtDecode } from 'jwt-decode'
import youbora from 'youboralib'
import { getDeviceInfo } from './index'
import 'youbora-adapter-shaka'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { version } from './../../package.json'

/** YOUBORA_ACCOUNT_CODE */
export const YOUBORA_ACCOUNT_CODE = import.meta.env.VITE_YOUBORA_ACCOUNT_CODE

/** 基础数据 */
export const basicData = () => {
  const route = router.currentRoute.value
  if (route?.query?.utm_source || route?.query?.utm_medium || route?.query?.utm_campaign) {
    Cookies.set(
      'utm',
      `${JSON.stringify({
        utm_source: route?.query?.utm_source || '',
        utm_medium: route?.query?.utm_medium || '',

        utm_campaign: route?.query?.utm_campaign || ''
      })}`
    )
  }
  if (Cookies.get('utm')) {
    try {
      const utm = JSON.parse(decodeURIComponent(Cookies.get('utm')))
      for (const key in utm) {
        if (utm[key]) {
          basicData[key] = utm[key]
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  basicData['tvbAccountID'] = '0'
  if (Cookies.get('tvbcoms')) {
    let tvbcoms = Cookies.get('tvbcoms')
    try {
      let token = jwtDecode(tvbcoms)
      basicData['tvbAccountID'] = token?.tvb_account_id || '0'
      // basicData['gender'] = token?.gender || 'NULL'
    } catch (err) {
      console.error('jwt decode err: ', err)
    }
  }
  return basicData
}

/** 页面 */
export const pageview = ({ ...other }) => {
  if (isBot()) return
  const trackingContent = {
    ...basicData(),
    event: 'scnOpen',
    ...other
  }
  window.dataLayer.push(trackingContent)
}

/** 點擊 */
export const action = ({ ...other }) => {
  if (isBot()) return
  const trackingContent = {
    ...basicData(),
    event: 'btnClick',
    ...other
  }
  window.dataLayer.push(trackingContent)
}

/** 高亮 */
export const impression = ({ ...other }) => {
  if (isBot()) return
  const trackingContent = {
    ...basicData(),
    event: 'impression',
    ...other
  }
  window.dataLayer.push(trackingContent)
}

/** 弹出 */
export const popUp = ({ ...other }) => {
  if (!isBot()) return
  const trackingContent = {
    ...basicData(),
    event: 'popUp',
    ...other
  }
  window.dataLayer.push(trackingContent)
}

export const getTagDeviceId = () => {
  let deviceid = localStorage.getItem('tag_deviceid')?.toString()
  if (!deviceid || (deviceid && deviceid.length !== 26)) {
    if (Cookies.get('tag_deviceid')) {
      deviceid = Cookies.get('tag_deviceid')
    } else {
      deviceid =
        (
          Math.floor(Math.random() * (9999999999999999 - 1000000000000000)) + 1000000000000000
        ).toString() + Math.floor(Date.now() / 1000).toString()
    }
  }
  localStorage.setItem('tag_deviceid', deviceid)
  Cookies.set('tag_deviceid', deviceid, { path: '/', domain: 'mytvsuper.com', expires: 365 * 2 })
  return deviceid
}

/** 视频埋点 */
export const youboras = ({
  videoTitle = '',
  programTitle = '',
  player = null,
  videoSrc = '',
  contentId = '',
  articleId = ''
}) => {
  const youboraPlugin = new youbora.Plugin({ accountCode: YOUBORA_ACCOUNT_CODE })
  const { config } = useAppStore()
  const { userInfo } = useUserStore()
  const deviceInfo = getDeviceInfo()
  const tagDeviceId = getTagDeviceId()
  const effectiveType = navigator?.connection?.effectiveType?.toUpperCase?.() || ''
  const mobileType = effectiveType ? `mobile_${effectiveType}` : 'wifi'
  const youboraOption = {
    username: userInfo?.id || 'guest',
    accountCode: YOUBORA_ACCOUNT_CODE,
    enableAnalytics: true,
    httpSecure: true,
    'content.title': videoTitle,
    'content.program': programTitle,
    'content.drm': 'MPS',
    'content.resource': videoSrc,
    'content.isLive': false,
    'content.isLive.noSeek': true,
    'content.playbackType': 'ShortVideo',
    'content.metadata': {
      filename: videoTitle,
      page_path: location.href,
      content_id: contentId,
      article_id: articleId,
      UUID4: config?.uuid ?? localStorage.getItem('uuid')
    },
    'content.customDimension.1': 'tvb_com_web',
    'content.customDimension.2': tagDeviceId ?? config?.uuid,
    'content.customDimension.3': '',
    'content.customDimension.4': '',
    'content.customDimension.5': deviceInfo?.code?.includes('PC') ? 'pc_network' : mobileType,
    'content.customDimension.6': '',
    'content.customDimension.7': '',
    'content.customDimension.8': tagDeviceId ?? config?.uuid,
    'content.customDimension.10': version,
    'content.customDimension.12': '',
    'device.code': deviceInfo.code,
    host: 'youbora.tvb.com'
  }
  youboraPlugin.setOptions(youboraOption)
  try {
    youboraPlugin.setAdapter(new youbora.adapters.Shaka(player))
  } catch (error) {
    console.error(error)
  }
}
